import type { GeofenceCrossingKind } from '@chukua/common';

/** How a truck entering or leaving a watched zone reads on a zone's panel and on a trip. */
export const CROSSING_KIND_LABELS: Record<GeofenceCrossingKind, string> = { enter: 'Arrived', exit: 'Left' };
